import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import TableWithPagination from "../../../components/TableWithPagination";
import { useLoanContext } from "../LoanContext";
import axios from "axios";


interface Party {
  partyType?: string;
  accountName?: string;
  email?: string;
  loanId?: string;
}

const PartiesTab = () => {
  const [parties, setParties] = useState<Party[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { loan } = useLoanContext();
  const { loanId } = useParams(); // Get loanId directly from URL params


  useEffect(() => {
    if (!loanId || !loan) {
      if (!loanId) {
        setError("No loanId provided.");
      } else if (!loan) {
        setError("Loading loan data...");
      }
      setLoading(false);
      return;
    }
    setLoading(true);
    setError("");
    axios
      .get(`/api/parties?loanId=${loanId}`, {
        withCredentials: true,
      })
      .then((res) => {
        setParties(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.response?.data?.error || "Failed to fetch parties.");
        setLoading(false);
      });
  }, [loanId, loan]);

  if (loading)
    return (
      <Box textAlign="center" mt={8}>
        <Typography color="#fff">Loading parties...</Typography>
      </Box>
    );
  if (error)
    return (
      <Box textAlign="center" mt={8}>
        <Typography color="error.main">{error}</Typography>
      </Box>
    );

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          textAlign: "left",
          color: "#fff",
          fontWeight: 600,
        }}
      >
        Party Details
      </Typography>
      <TableWithPagination
        columns={[
          {label:"Party ID" , key:"name"},
          { label: "Party Name", key: "accountName" },
          { label: "Party Type", key: "partyType" },
          { label: "Email", key: "email" },
        ]}
        rows={parties as Record<string, unknown>[]}
        getRowKey={(row) => (row.email || row.accountName || row.partyType || '') as string}
        rowsPerPage={5}
      />
    </Box>
  );
};

export default PartiesTab;
